var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataPermission.includes('CNPS_CSTM_NEXTLEND_LIST'))?_c('div',[_c('iframe',{attrs:{"src":_vm.urlFrame}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }